import React, { useEffect } from 'react'
import { withRouter } from '@fs/zion-router'
import { hasRestorePoint, isRestoringCurrentLocation } from './scrollRestoration'

// FIXME: memory leak when testing
function ScrollToTop({ history, children }) {
  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      // The page restores this itself. See docs/decisions/CDR-003-schedule-scroll-restoration.md
      if (action === 'POP' && hasRestorePoint(location.key)) return

      // A page rewriting its own URL must not discard a restore still running for it.
      if (isRestoringCurrentLocation()) return

      window.scrollTo(0, 0)
    })
    return () => {
      unlisten()
    }
  }, [history])

  return <>{children}</>
}

export default withRouter(ScrollToTop)
